var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "退货（F4）",
        maskClosable: false,
        width: "720px",
        footer: null,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "return-search" },
        [
          _c("a-input-search", {
            staticStyle: { flex: "1" },
            attrs: {
              placeholder: "输入小票号/单号查询（留空显示最近 10 单）",
              enterButton: "查询",
            },
            on: { search: _vm.loadOrders },
            model: {
              value: _vm.keyword,
              callback: function ($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword",
            },
          }),
        ],
        1
      ),
      !_vm.currentOrder
        ? _c(
            "div",
            { staticClass: "order-list" },
            [
              !_vm.orders.length
                ? _c("div", { staticClass: "empty-tip" }, [
                    _vm._v("暂无符合条件的收银单"),
                  ])
                : _vm._e(),
              _vm._l(_vm.orders, function (order) {
                return _c(
                  "div",
                  {
                    key: order.id,
                    staticClass: "order-card",
                    on: {
                      click: function ($event) {
                        return _vm.pickOrder(order)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "order-line" }, [
                      _c("span", { staticClass: "order-no" }, [
                        _vm._v(_vm._s(order.number)),
                      ]),
                      _c("span", { staticClass: "order-member" }, [
                        _vm._v(_vm._s(order.memberName || "散客")),
                      ]),
                      _c("span", { staticClass: "order-amount" }, [
                        _vm._v("¥" + _vm._s(_vm.format(order.totalPrice))),
                      ]),
                    ]),
                    _c("div", { staticClass: "order-line sub" }, [
                      _c("span", [_vm._v(_vm._s(order.operTime))]),
                      _c("span", [_vm._v("支付：" + _vm._s(order.payType))]),
                      order.refundBlocked
                        ? _c("span", { staticClass: "blocked" }, [
                            _vm._v("储值支付 · 不可在此退货"),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
            ],
            2
          )
        : _c("div", [
            _c("div", { staticClass: "picked-head" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.currentOrder.number) +
                    " · " +
                    _vm._s(_vm.currentOrder.memberName || "散客") +
                    " · ¥" +
                    _vm._s(_vm.format(_vm.currentOrder.totalPrice))
                ),
              ]),
              _c("a", { on: { click: _vm.backToList } }, [_vm._v("返回重选")]),
            ]),
            _c(
              "div",
              { staticClass: "item-list" },
              _vm._l(_vm.currentOrder.items, function (item) {
                return _c(
                  "div",
                  { key: item.itemId, staticClass: "item-row" },
                  [
                    _c("a-checkbox", {
                      attrs: {
                        checked: _vm.isSelected(item.itemId),
                        disabled:
                          !item.returnable || Number(item.returnable) <= 0,
                      },
                      on: {
                        change: (e) => _vm.toggleItem(item, e.target.checked),
                      },
                    }),
                    _c("span", { staticClass: "item-name" }, [
                      _vm._v(
                        _vm._s(item.materialName) +
                          "（" +
                          _vm._s(item.unit) +
                          "）"
                      ),
                    ]),
                    _c("span", { staticClass: "item-info" }, [
                      _vm._v(
                        "原 " +
                          _vm._s(item.operNumber) +
                          " · 已退 " +
                          _vm._s(item.returnedNumber)
                      ),
                    ]),
                    _c("span", { staticClass: "item-price" }, [
                      _vm._v("¥" + _vm._s(_vm.format(item.unitPrice))),
                    ]),
                    _vm.isSelected(item.itemId)
                      ? _c("div", { staticClass: "stepper" }, [
                          _c(
                            "a",
                            {
                              staticClass: "step-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.changeQty(item, -1)
                                },
                              },
                            },
                            [_vm._v("−")]
                          ),
                          _c("input", {
                            staticClass: "step-input",
                            attrs: { inputmode: "decimal" },
                            domProps: { value: _vm.qtyMap[item.itemId] },
                            on: { change: (e) => _vm.onQtyInput(item, e) },
                          }),
                          _c(
                            "a",
                            {
                              staticClass: "step-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.changeQty(item, 1)
                                },
                              },
                            },
                            [_vm._v("＋")]
                          ),
                        ])
                      : _c("span", { staticClass: "item-returnable" }, [
                          _vm._v("可退 " + _vm._s(item.returnable)),
                        ]),
                  ],
                  1
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "return-footer" },
              [
                _c("span", [
                  _vm._v("退货合计："),
                  _c("span", { staticClass: "return-total" }, [
                    _vm._v("¥" + _vm._s(_vm.format(_vm.returnTotal))),
                  ]),
                ]),
                _c(
                  "a-button",
                  {
                    attrs: {
                      type: "danger",
                      loading: _vm.settling,
                      disabled: !_vm.selectedItems.length,
                    },
                    on: { click: _vm.confirmReturn },
                  },
                  [_vm._v("\n        确认退货\n      ")]
                ),
              ],
              1
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }